var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSmallerDisplay())?_c('v-card-text',[_c('v-btn',{attrs:{"x-small":"","elevation":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.goBack()}}},[_c('ChevronLeftIcon',{staticStyle:{"margin-bottom":"0px"}}),_vm._v(" "+_vm._s(_vm.$t('message.back'))+" ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }